import Api from 'libs/api';

class CompaniesApi extends Api {
  constructor() {
    super('admin/companies/');
  }
}

export default CompaniesApi;
